import React, { ReactElement } from 'react'

import { useIsAuthenticated } from '@azure/msal-react'

import SignInButton from './SignInButton'
import SignOutButton from './SignOutButton'

function SignInSignOutButton(): ReactElement {
  const isAuthenticated = useIsAuthenticated()

  if (isAuthenticated) {
    return <SignOutButton />
  } else {
    return <SignInButton />
  }
}

export default SignInSignOutButton
